<template>
    <Layout>
      <PageHeader :title="title" :items="items"></PageHeader>
      <div class="row" id="series">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row align-items-center mb-4">
                <div class="col-md-6">
                  <div class="form-inline navbar-search">
                    <div class="input-group">
                      <input v-on:keyup="search" name="title" class="form-control bg-light border-0 small"
                        placeholder="Search Title" aria-label="Search" aria-describedby="basic-addon2" value=""
                        v-model="filter" />
                      <div class="input-group-append">
                        <button class="btn btn-search" @click="searchFor">
                          <i class="fas fa-search fa-sm"> </i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  
                </div>
              </div>
              <div v-if="showInput" class="row col-12">
                <div class="input-group col-5">
                  <multiselect
                          @search-change="fetchMemberList"
                          id="member"
                          v-model="member_tagging"
                          :options="memberList"
                          :multiple="false"
                          track-by="member_id"
                          label="fnameAndLname"
                          placeholder="Type here to search"
                        >
                          <span slot="noOptions"> Type here to search </span>
                        </multiselect>
                </div>
                <div class="input-group col-5">
                  <multiselect
                          @search-change="fetchAiToolsList"
                          id="services"
                          v-model="ai_services"
                          :options="aiServiceList"
                          :multiple="true"
                          track-by="id"
                          label="title"
                          placeholder="Type here to search"
                        >
                          <span slot="noOptions"> Type here to search </span>
                        </multiselect>
                </div>
                <div class="col-2"><button class="btn btn-primary" @click="submitMemberMapping">Add Member</button></div>
              </div>
              <div class="table-responsive mb-0">
                <div v-if="!tableData.data || tableData.data.length === 0" class="text-center text-muted mb-3">
                  <p style="font-size: 1.25rem;"><strong>No data found.</strong></p>
                </div>

                <b-table v-if="tableData.data && tableData.data.length > 0" striped bordered :items="tableData.data" :fields="fields" :sort-by.sync="sortBy" :per-page="0"
                  :current-page="currentPage" :sort-desc.sync="sortDesc" :filter-included-fields="filterOn"
                  @filtered="onFiltered" responsive="sm" class="table-bordered table-hover" :key="key">
                  <!-- <template v-can="'update-posts-status'" v-slot:cell(post_status)="row">
                    <b-form-checkbox switch class="mb-1" @change="updateStatus(row.item.id)"
                      :checked="row.item.post_status == 1 ? true : false">
                    </b-form-checkbox>
                  </template> -->
                  <!-- <template v-can="'update-social-media-status'" v-slot:cell(social_media)="row">
                    <b-form-checkbox 
                      switch 
                      class="mb-1" 
                      :disabled="row.item.social_media == 1" 
                      @change="socialUpdateStatus(row.item.id)" 
                      :checked="row.item.social_media == 1">
                    </b-form-checkbox>
                  </template> -->
                  <template v-can="'ai-tools-members-services'" v-slot:cell(tokens)="row">
                    <div>
                      <!-- Editing mode -->
                      <div v-if="editedRowId === row.item.id">
                        <div class="input-group" style="max-width: 200px;">
                          <input
                            type="number"
                            v-model.number="addTokens"
                            placeholder="Add tokens"
                            class="form-control"
                          />
                          <input
                            type="number"
                            :value="existingTokens + addTokens"
                            readonly
                            class="form-control"
                          />
                          <button class="btn btn-success" @click="saveTokens(row.item.id)">Save</button>
                        </div>
                      </div>

                      <!-- View mode -->
                      <div v-else @click="enableTokenEdit(row.item)" style="cursor: pointer;">
                        <p>{{ row.item.tokens }}</p>
                      </div>
                    </div>
                  </template>
                  <template v-can="'ai-tools-members-services'" v-slot:cell(show_details)="row">
                      <b-button @click="fetchTooldetails(row.item)" variant="outline-primary" class="btn-sm m-1">Show Details</b-button>
                  </template>
                  <template v-slot:cell(type)="row">
                      <p v-if="row.item.type == 'credit'" style="color: green;">{{ capitalize(row.item.type) }}</p>
                      <p v-else style="color: red;">{{ capitalize(row.item.type) }}</p>
                  </template>

                </b-table>
              </div>
              <template v-if="tableData.total_pages > 1">
                <div class="data_paginate">
                  <div class="dataTables_paginate paging_simple_numbers d-flex justify-content-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" first-number last-number :total-rows="tableData.total"
                        :total-pages="tableData.total_pages" :per-page="tableData.per_page"></b-pagination>
                    </ul>
                  </div>
                  <div class="form-inline navbar-search">
                    <span class="mr-2">Go to a Particular Paginated Page :</span>
                    <div class="input-group">
                      <b-form-input id="case" v-model="pageNo" placeholder="Enter Page No" class="in-width">
                      </b-form-input>
                      <div class="input-group-append">
                        <button class="btn btn-search" @click="filterPage">
                          <i class="fas fa-search fa-sm"> </i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  </template>
  
  <script>
  import Layout from "../../../layouts/main";
  import PageHeader from "@/components/page-header";
  import MixinRequest from "../../../../mixins/request";
  import postsMixin from "../../../../mixins/ModuleJs/ai-tools-members-transaction";
  import Multiselect from "vue-multiselect";
  
  export default {
    data() {
      return {
        title: "List AI Tools Members",
        showInput: false,
        items: [
          {
            text: "back",
            href: "/ai/ai-tools-members",
          },
          {
            text: "List",
          },
        ],
      };
    },
    mixins: [postsMixin, MixinRequest],
    components: {
      Layout,
      PageHeader,
      Multiselect,
    },
  };
  </script>
  